import _import from './_import.js';

export default [
     //paygo    
     {
        path: '/paygo/home',
        name: 'home',
        component: _import('message/paygo'),
        meta:{
            title:"Home"
        }
    },
    {
        path: '/paygo/rate',
        name: 'rate',
        component: _import('paygo/RateView'),
        meta:{
            title:'rate'
        }
    },
    {
        path: '/paygo/record',
        name: 'record',
        component: _import('paygo/DataRecord'),
        meta:{
            title:'record'
        }
    }
];


// WEBPACK FOOTER //
// ./src/router/paygo.js